import { Navigate, Outlet, useLocation } from 'react-router';
import { useOnboardingStore } from '@/stores/onboardingStore';
import { useAuthStore } from '@/stores/authStore';

export function OnboardingGuard() {
  const hasCompleted = useOnboardingStore((s) => s.hasCompletedOnboarding);
  const hasSeenAuth = useOnboardingStore((s) => s.hasSeenAuthPrompt);
  const authMode = useAuthStore((s) => s.authMode);
  const { pathname } = useLocation();
  const isOnboardingRoute = pathname.startsWith('/onboarding');

  if (!hasCompleted && !isOnboardingRoute) {
    return <Navigate to="/onboarding/welcome" replace />;
  }
  if (hasCompleted && isOnboardingRoute) {
    return <Navigate to={hasSeenAuth ? '/app' : '/login'} replace />;
  }
  if (hasCompleted && !hasSeenAuth && authMode === 'anonymous' && !isOnboardingRoute) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
